import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
  subtitle: {
    color: '#000A8C',
    fontSize: 26,
    marginTop: 15,
  },
  visibilityPermission: {
    width: '100%',
  },
  select: {
    fontFamily: 'Poppins',
    fontSize: '14px',
    '& .css-1wa3eu0-placeholder': {
      color: '#23296F !important',
      fontSize: '14px !important',
    },
    '& .css-1dimb5e-singleValue': {
      color: '#23296F !important',
      fontSize: '14px !important',
    },
    '& .css-26l3qy-menu': {
      fontSize: '14px !important',
    },
    '& .css-1pahdxg-control': {
      fontSize: '14px !important',
    },
    '& .css-1s2u09g-control': {
      fontSize: '14px !important',
    },
    '& .css-1hb7zxy-IndicatorsContainer': {
      fontSize: '14px !important',
    },
    '& [class*="placeholder"]': {
      color: '#23296F !important',
      fontSize: '14px !important',
    },
    '& [class*="singleValue"]': {
      color: '#23296F !important',
      fontSize: '14px !important',
    },
    '& [class*="control"]': {
      fontSize: '14px !important',
    },
  },
  inputError: {
    border: `2px solid red`,
    borderRadius: '4px'
  },
  textError: {
    color: 'red'
  },
  noBorder: {
    border: 'none !important',
    padding: 0,
  }
}));
